import { render } from "./OneOnOneStreamLayout.vue?vue&type=template&id=af5ac2bc&scoped=true"
import script from "./OneOnOneStreamLayout.vue?vue&type=script&lang=js"
export * from "./OneOnOneStreamLayout.vue?vue&type=script&lang=js"

import "./OneOnOneStreamLayout.vue?vue&type=style&index=0&id=af5ac2bc&lang=scss"
import "./OneOnOneStreamLayout.vue?vue&type=style&index=1&id=af5ac2bc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-af5ac2bc"

export default script